import { render } from "./phone.vue?vue&type=template&id=123b48fc&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import "./phone.vue?vue&type=style&index=0&id=123b48fc&lang=css"
import "./phone.vue?vue&type=style&index=1&id=123b48fc&lang=stylus&scoped=true"
import "./phone.vue?vue&type=style&index=2&id=123b48fc&lang=stylus&scoped=true"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123b48fc"]])

export default __exports__